import React, { useState } from 'react';
import { changeFieldName } from '../../APICalls/PutRequests';
import Cookies from 'js-cookie';
import Popup from "../../UI/Popup";
import './FieldNamePopup.scss';

const FieldNamePopup = ({
  isVisible,
  field,
  handleFieldNamePopupClose,
  onFieldNameUpdated,
}) => {
  const [newName, setNewName] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!newName.trim()) return;

    changeFieldName(field.id, { name: newName }, Cookies.get('session_key'))
      .then(() => {
        onFieldNameUpdated(newName);
        handleFieldNamePopupClose();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Popup
      isVisible={isVisible}
      isSaveDisabled={!newName.trim()}
      headerText={`Edit ${field.name}'s Name`}
      saveButtonText="Confirm"
      handleClose={handleFieldNamePopupClose}
      handleSave={handleSubmit}
      popupContent={(
        <form className="field-name-popup__form" onSubmit={handleSubmit}>
          <label className="field-name-popup__label" htmlFor="newName">
            New name:
          </label>

          <input
            className="field-name-popup__input"
            type="text"
            id="newName"
            name="newName"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />
        </form>
      )}
    />
  );
};

export default FieldNamePopup;

